"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsNullOrUndef_1 = __importDefault(require("../../typeAssertions/valueIsNullOrUndef"));
const getEnsuredProjectIdFromProcessor_1 = __importDefault(require("../getEnsuredProjectIdFromProcessor"));
const callableSetOtherUserCustomData = async ({ entryVars: { key, value, userId, appId: selectedAppId, }, callbacks, functionId, executeProcesses, processor, }) => {
    try {
        if (!userId || (0, valueIsNullOrUndef_1.default)(value) || !key || typeof key !== 'string') {
            executeProcesses(functionId, callbacks.errorProcess, { message: 'All entry vars are required.' });
        }
        else {
            const projectId = (0, getEnsuredProjectIdFromProcessor_1.default)('setOtherUserCustomData', processor);
            const appId = processor.root.getAppId();
            if (!appId) {
                throw new Error('setUserCustomData: no appId found in app');
            }
            const memberCustomDataRef = processor.root.firebase.database()
                .ref(`projects/${projectId}/apps/${selectedAppId || appId}/members/${userId}/customData`);
            const actualValue = value === undefined ? null : value;
            await memberCustomDataRef.child(key).set(actualValue);
            executeProcesses(undefined, callbacks.successProcess);
        }
    }
    catch (error) {
        executeProcesses(functionId, callbacks.errorProcess, error);
    }
};
exports.default = callableSetOtherUserCustomData;
